<template>
  <v-container>
    <v-layout>
      <v-flex md8 sm10 xs12 offset-md2 offset-sm1>
        <v-card>
          <v-card-title>{{
            (serverInfo && serverInfo.virtualserverName) || "Sunucu"
          }}</v-card-title>
          <v-card-text>
            <div @contextmenu.prevent="openRootMenu($event)">
              <v-treeview :items="channelTree" :open="itemIDs" dense>
                <template #label="{ item }">
                  <channel
                    v-if="item.channelName"
                    :channel="item"
                    :queryUser="queryUser"
                    :afkCid="serverInfo.virtualserverChannelAFK"
                  ></channel>
                  <client
                    v-else
                    :client="item"
                    :serverGroups="serverGroups"
                  ></client>
                </template>
              </v-treeview>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-menu
      v-model="rootMenu"
      :position-x="rootMenuX"
      :position-y="rootMenuY"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item @click="createRootChannel">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Kanal Oluştur</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-speed-dial right bottom fixed>
      <template #activator>
        <v-btn fab color="primary" dark>
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <!-- Kanal Ekle -->
      <v-btn fab color="primary" dark small :to="{ name: 'channel-add' }">
        <v-icon large :title="channelIconTitle">{{ channelIcon }}</v-icon>
      </v-btn>

      <!-- Boşluk (Spacer) Ekle -->
      <v-btn fab color="primary" dark small :to="{ name: 'spacer-add' }">
        <v-icon>mdi-keyboard-space</v-icon>
      </v-btn>
    </v-speed-dial>
  </v-container>
</template>

<script>
export default {
  components: {
    Channel: () => import("@/components/ServerViewerChannel"),
    Client: () => import("@/components/ServerViewerClient"),
  },

  data() {
    return {
      serverInfo: {},
      channelList: [],
      clientList: [],
      itemIDs: [],
      channelTree: [],
      currentChannel: {},
      textPrivates: [],
      serverGroups: [],
      rootMenu: false,
      rootMenuX: 0,
      rootMenuY: 0,

      _ev: null,
      _ltTimer: null,
      _listenersOn: false,
      _ltInFlight: false,
      _ltQueued: false,
    };
  },

  async created() {
    try {
      this.serverInfo = await this.getServerInfo();
      this.serverInfo.unreadMessages = 0;

      this.serverGroups = await this.getServerGroupList();
      this.channelList = await this.getChannelList();
      this.clientList = await this.getClientList();
      this.queryUser = await this.whoAmI();

      this.channelTree = this.createNestedList(
        this.mergedList(this.clientList, this.channelList)
      );

      this.currentChannel = this.getCurrentChannel(
        this.channelList,
        this.queryUser
      );

      this.openAllChannels();
      this.addEventListeners();
      this.getAllClientAvatars();
    } catch (err) {
      this.$toast.error(err.message);
    }
  },

  beforeRouteLeave(to, from, next) {
    try {
      this.removeEventListeners();
    } catch (_) {}
    try {
      clearTimeout(this._ltTimer);
      this._ltTimer = null;
    } catch (_) {}
    next();
  },

  beforeDestroy() {
    try {
      this.removeEventListeners();
    } catch (_) {}
    try {
      clearTimeout(this._ltTimer);
      this._ltTimer = null;
    } catch (_) {}
  },
  computed: {
    channelIcon() {
      const c = this.channel || {};

      // şifre varsa kilit (öncelik bu)
      if (Number(c.channelFlagPassword) === 1) return "mdi-lock";

      // default kanal
      if (Number(c.channelFlagDefault) === 1) return "mdi-star";

      // kalıcılık tipleri
      if (Number(c.channelFlagPermanent) === 1) return "mdi-folder";
      if (Number(c.channelFlagSemiPermanent) === 1) return "mdi-folder-outline";
      if (Number(c.channelFlagTemporary) === 1) return "mdi-timer-sand";

      // fallback
      return "mdi-chat";
    },

    channelIconTitle() {
      const c = this.channel || {};
      if (Number(c.channelFlagPassword) === 1) return "Şifreli Kanal";
      if (Number(c.channelFlagDefault) === 1) return "Varsayılan Kanal";
      if (Number(c.channelFlagPermanent) === 1) return "Kalıcı Kanal";
      if (Number(c.channelFlagSemiPermanent) === 1) return "Yarı Kalıcı Kanal";
      if (Number(c.channelFlagTemporary) === 1) return "Geçici Kanal";
      return "Kanal";
    },
    queryUser: {
      get() {
        return this.$store.state.query.queryUser;
      },
      set(value) {
        this.$store.commit("saveUserInfo", value);
      },
    },
  },
  methods: {
    // =========================
    // Tree helpers
    // =========================
    createNestedList(list, itemID = 0) {
      const out = [];

      for (const item of list) {
        if (item.parentItemId == itemID) {
          const children = this.createNestedList(list, item.itemId);
          if (children.length) item.children = children;
          out.push(item);
        }
      }

      return out;
    },

    mergedList(clientlist, channellist) {
      return [...clientlist, ...channellist].map((item) => {
        // client
        if (item.clientNickname) {
          return {
            id: `${item.clid}-client`,
            name: item.clientNickname,
            parentItemId: item.cid,
            itemId: null,
            ...item,
          };
        }

        // channel
        return {
          id: `${item.cid}-channel`,
          name: item.channelName,
          itemId: item.cid,
          parentItemId: item.pid,
          ...item,
        };
      });
    },

    openAllChannels() {
      this.itemIDs = []; // ✅ şart (yoksa büyür / saçmalar)
      this.channelList.forEach((ch) => this.itemIDs.push(`${ch.cid}-channel`));
    },

    // =========================
    // TS execute wrappers
    // =========================
    getServerInfo() {
      return this.$TeamSpeak.execute("serverinfo").then((x) => x[0]);
    },
    getChannelList() {
      return this.$TeamSpeak.execute("channellist", {}, ["-flags"]);
    },
    getClientList() {
      return this.$TeamSpeak.execute("clientlist", {}, [
        "-voice",
        "-away",
        "-groups",
        "-uid", // ✅ UID gelsin
        "-ip", // ✅ IP gelsin
      ]);
    },
    getServerGroupList() {
      return this.$TeamSpeak.execute("servergrouplist");
    },
    whoAmI() {
      return this.$TeamSpeak.execute("whoami").then((x) => x[0]);
    },

    // =========================
    // Avatars
    // =========================
    getSingleClientAvatar(e) {
      this.$store.dispatch("getClientAvatars", [
        e.detail.client.clientDatabaseId,
      ]);
    },
    getAllClientAvatars() {
      this.$store.dispatch(
        "getClientAvatars",
        this.clientList.map((c) => c.clientDatabaseId)
      );
    },

    // =========================
    // Current channel
    // =========================
    getCurrentChannel(channelList, queryUser) {
      const q = queryUser || {};
      const myCid = Number(q.clientChannelId || 0);
      if (!myCid) return null;
      return (channelList || []).find((ch) => Number(ch.cid) === myCid) || null;
    },
    async updateCurrentChannel() {
      try {
        this.queryUser = await this.whoAmI();
        this.currentChannel = this.getCurrentChannel(
          this.channelList,
          this.queryUser
        );
      } catch (err) {
        this.$toast.error(err.message);
      }
    },

    // =========================
    // Load control (anti-spam)
    // =========================

    // tek timer + tek kuyruk: notify yağsa bile en fazla 1 kez daha çalışır
    scheduleLoad(reason = "") {
      // load çalışıyorsa sadece "1 tane daha" işaretle
      if (this._ltInFlight) {
        this._ltQueued = true;
        return;
      }

      // timer zaten kuruluysa yeniden kurma
      if (this._ltTimer) return;

      this._ltTimer = setTimeout(async () => {
        this._ltTimer = null;

        await this.loadChannelTree();

        // load sırasında tekrar çağrı geldiyse 1 kere daha dön
        if (this._ltQueued) {
          this._ltQueued = false;
          this.scheduleLoad("queued");
        }
      }, 250);
    },

    // (istersen dışarıdan manuel çağırırsın diye bıraktım)
    loadChannelTreeDebounced() {
      clearTimeout(this._ltTimer);
      this._ltTimer = setTimeout(() => this.loadChannelTree(), 300);
    },

    async loadChannelTree() {
      if (this._ltInFlight) return;
      this._ltInFlight = true;

      try {
        // serverGroups boşsa 1 kere çek
        if (!this.serverGroups || !this.serverGroups.length) {
          this.serverGroups = await this.getServerGroupList();
        }

        this.channelList = await this.getChannelList();
        this.clientList = await this.getClientList();

        this.channelTree = this.createNestedList(
          this.mergedList(this.clientList, this.channelList)
        );

        this.openAllChannels();
        await this.updateCurrentChannel();
      } catch (err) {
        this.$toast.error(err.message);
      } finally {
        this._ltInFlight = false;
      }
    },

    // =========================
    // Event listeners (NO duplicate)
    // =========================
    addEventListeners() {
      if (this._listenersOn) return;
      this._listenersOn = true;

      if (!this._ev) {
        this._ev = {
          clientmoved: () => this.scheduleLoad("clientmoved"),

          clientconnect: (e) => {
            this.scheduleLoad("clientconnect");
            this.getSingleClientAvatar(e);
          },

          clientdisconnect: () => this.scheduleLoad("clientdisconnect"),

          channeldelete: () => this.scheduleLoad("channeldelete"),

          // ✅ SERVER GROUP / CLIENT UPDATE
          clientupdated: () => this.scheduleLoad("clientupdated"),
        };
      }

      // garanti: önce sök, sonra tak
      this.removeEventListeners(false);

      this.$TeamSpeak.on("clientmoved", this._ev.clientmoved);
      this.$TeamSpeak.on("clientconnect", this._ev.clientconnect);
      this.$TeamSpeak.on("clientdisconnect", this._ev.clientdisconnect);
      this.$TeamSpeak.on("channeldelete", this._ev.channeldelete);

      // ✅ EKLENDİ
      this.$TeamSpeak.on("clientupdated", this._ev.clientupdated);
    },

    removeEventListeners(resetFlag = true) {
      if (!this._ev) return;

      const off = (name, fn) => {
        try {
          this.$TeamSpeak.__proto__.removeEventListener(name, fn);
        } catch (_) {}
      };

      off("clientmoved", this._ev.clientmoved);
      off("clientconnect", this._ev.clientconnect);
      off("clientdisconnect", this._ev.clientdisconnect);
      off("channeldelete", this._ev.channeldelete);
      off("clientupdated", this._ev.clientupdated);

      if (resetFlag) this._listenersOn = false;
    },

    // =========================
    // UI actions
    // =========================
    openRootMenu(e) {
      this.rootMenuX = e.clientX;
      this.rootMenuY = e.clientY;
      this.rootMenu = true;
    },
    createRootChannel() {
      this.rootMenu = false;
      this.$router.push({ name: "channel-add", query: { pid: 0 } });
    },
  },
};
</script>
<style>
/* Treeview node yüksekliği */
.v-treeview-node__root {
  min-height: 16px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* List item yüksekliği (kanal satırları) */
.v-list-item {
  min-height: 16px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Treeview iç boşlukları */
.v-treeview-node__content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.v-list-item__content {
  padding: 0 !important;
}
</style>
